<template>
  <v-dialog v-model="dialog" max-width="620" persistent>
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on">
        <v-list-item-icon>
          <v-icon>mdi-upload</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Ladda upp medlemmar</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-card>
      <v-card-title>
        Ladda upp medlemmar från CSV
      </v-card-title>
      <v-card-text>
        <v-file-input accept=".csv" v-model="file" label="Fil"></v-file-input>
        <v-btn
          v-if="weightedVotes"
          text
          href="https://firebasestorage.googleapis.com/v0/b/percap-7af8f.appspot.com/o/templates%2Fpercap%20-%20ro%CC%88stra%CC%88tterexempel%20viktade%20andelar.csv?alt=media&token=21d47bfc-cd7a-45a3-a5fc-72df3db611f9"
          >Ladda ner exempelfil </v-btn
        ><v-btn
          v-else
          text
          href="https://firebasestorage.googleapis.com/v0/b/percap-7af8f.appspot.com/o/templates%2Fpercap%20-%20r%C3%B6str%C3%A4tterexempel.csv?alt=media&token=1901e108-b613-442b-8604-5946292770a4"
          >Ladda ner exempelfil
        </v-btn>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Avbryt</v-btn>
        <v-btn text color="primary" type="submit" @click="uploadFile"
          >Ladda upp</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { storage } from "@/plugins/firebase";

export default {
  props: {
    meetingId: String,
    weightedVotes: Boolean
  },
  data() {
    return {
      dialog: false,
      file: null
    };
  },
  methods: {
    async uploadFile() {
      const storageRef = storage.ref();

      const success = await storageRef
        .child(`/csv/members/${this.meetingId}/members/` + this.file.name)
        .put(this.file);

      if (success) {
        this.close();
      }
    },
    close() {
      this.file = null;
      this.dialog = false;
    }
  }
};
</script>
